import { useEffect, useState } from 'react'
import CrudPage from '../../components/CrudPage'
import { formasPagoCrud, getClasesFormaPago } from '../../api/entities'
import { idOf } from '../../api/crud'

// ABM Formas de pago / Condiciones de venta. Lectura: GET /formapago?view=BaseList.
// VALIDADO EN VIVO contra el MT (2026-06-25, admin_fvv):
//   `clase` es @NotNull -> POST sin clase devuelve 400 [PROPERTY][clase][must not be null].
//   ALTA  POST /formapago { descripcion, clase:{id}, depositable } -> HTTP 200 (persiste id 36).
//   EDICIÓN PUT /formapago/{id} (mismo payload, id en URL) -> HTTP 200.
//   Catálogo de clases: GET /tipos/tipo/clase_forma_pago (Efectivo, Cheque, Tarjeta, etc.).
//   NOTA: el campo `utilizarEnCobros` NO existe en la entidad (no está en la vista ni se
//   acepta) — se eliminó. `codigo` lo asigna/gestiona el backend, no es input del alta.
export default function FormasPagoPage() {
  const [clases, setClases] = useState([])
  useEffect(() => { getClasesFormaPago().then(setClases).catch(() => {}) }, [])

  return (
    <CrudPage
      title="Formas de pago"
      api={formasPagoCrud}
      searchPlaceholder="Buscar por descripción"
      columns={[
        { key: 'descripcion', label: 'Descripción' },
        { key: 'clase.descripcion', label: 'Clase' },
        { key: 'depositable', label: 'Depositable', render: (r) => (r.depositable ? 'Sí' : 'No') },
      ]}
      fields={[
        { name: 'descripcion', label: 'Descripción', required: true, full: true },
        { name: 'clase', label: 'Clase', type: 'select', options: clases, required: true },
        { name: 'depositable', label: 'Depositable', type: 'checkbox' },
      ]}
      toPayload={(f) => ({ descripcion: f.descripcion, clase: idOf(f.clase), depositable: !!f.depositable })}
      fromEntity={(e) => ({ descripcion: e.descripcion, clase: e.clase, depositable: e.depositable })}
    />
  )
}
